import { render, staticRenderFns } from "./changeSubject.vue?vue&type=template&id=71414104&"
import script from "./changeSubject.vue?vue&type=script&lang=js&"
export * from "./changeSubject.vue?vue&type=script&lang=js&"
import style0 from "./changeSubject.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports